import React, { } from 'react';
import { Tab, Nav } from 'react-bootstrap';

import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import AccountSetting from './AccountSetting';
import GamificationSetting from './GamificationSetting';
import EmployeeHighlightSetting from './EmployeeHighlightSetting';
import SalesSetting from './SalesSetting';
import MainSetting from './MainSetting';
import StockControlSetting from './StockControlSetting';
import BrandingSetting from './BrandingSetting';
import AppointmentSetting from './AppointmentSetting';
import LocalStorageType from '../../../constants/LocalStorageType';
import Module from '../../../constants/Module';

const hasModuleAccess = (companyModules, module) =>
    !module || !Array.isArray(companyModules) || companyModules.includes(module);

const Setting = () => {

    const { t } = useTranslation();
    const { tab } = useParams();
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem(LocalStorageType.USER_DETAILS) || "{}");
    const isAdmin = user?.admin === true || user?.superAdmin === true;
    const companyModules = user?.companyPermissions;
    const settingSections = [
        {
            key: 'account',
            icon: 'fas fa-user-cog',
            title: t('account'),
            description: 'Atualize seus dados, email, senha e foto de perfil.',
            badge: 'Essencial',
            component: <AccountSetting />,
        },
        {
            key: 'branding',
            icon: 'fas fa-palette',
            title: 'Identidade visual',
            description: 'Personalize logo, aparência e elementos da sua marca.',
            badge: 'Marca',
            adminOnly: true,
            component: <BrandingSetting />,
        },
        {
            key: 'main',
            icon: 'fas fa-sliders-h',
            title: t('main'),
            description: 'Defina regras gerais, preferências operacionais e parâmetros-base.',
            badge: 'Operação',
            adminOnly: true,
            component: <MainSetting />,
        },
        {
            key: 'appointment',
            icon: 'fas fa-calendar-alt',
            title: t('appointments'),
            description: 'Ajuste agenda, fluxos e políticas de atendimento.',
            badge: 'Agenda',
            adminOnly: true,
            module: Module.APPOINTMENT,
            component: <AppointmentSetting />,
        },
        {
            key: 'gamification',
            icon: 'fas fa-trophy',
            title: t('gamification.label'),
            description: 'Gerencie incentivos, regras de pontos e engajamento.',
            badge: 'Engajamento',
            adminOnly: true,
            module: Module.GAMIFICATION,
            component: <GamificationSetting />,
        },
        {
            key: 'employee-highlight',
            icon: 'fas fa-medal',
            title: 'Destaque do mês',
            description: 'Defina os pesos usados para calcular o colaborador destaque do mês.',
            badge: 'Performance',
            adminOnly: true,
            module: Module.PERFORMANCE,
            component: <EmployeeHighlightSetting />,
        },
        {
            key: 'sales',
            icon: 'fas fa-shopping-bag',
            title: t('sales'),
            description: 'Ajuste parâmetros comerciais, vendas e fluxos de caixa relacionados.',
            badge: 'Receita',
            adminOnly: true,
            module: Module.SALES,
            component: <SalesSetting />,
        },
        {
            key: 'stock-control',
            icon: 'fas fa-boxes',
            title: t('stock_management'),
            description: 'Organize estoque, reposição e políticas de movimentação.',
            badge: 'Estoque',
            adminOnly: true,
            module: Module.STOCK_CONTROL,
            component: <StockControlSetting />,
        },
    ];
    const availableSections = settingSections.filter((section) =>
        (!section.adminOnly || isAdmin) && hasModuleAccess(companyModules, section.module)
    );

    return (
        <>
            <Tab.Container activeKey={tab || 'account'} onSelect={(key) => navigate(`/setting/${key}`)}>
                <div className="setting-page">
                    <div className="card setting-nav-card border-0">
                        <div className="card-body">
                            <div className="setting-nav-card__header">
                                <span className="setting-nav-card__title">Áreas de configuração</span>
                                <span className="setting-nav-card__caption">Escolha uma área para ver e ajustar suas opções.</span>
                            </div>

                            <Nav className="nav setting-tabs setting-tabs--grid" id="setting-nav-tab" role="tablist" aria-label="Seções de configuração">
                                {availableSections.map((section) => (
                                    <Nav.Link
                                        key={section.key}
                                        className="nav-link setting-tab-link"
                                        id={`${section.key}-tab`}
                                        eventKey={section.key}
                                    >
                                        <span className="setting-tab-link__icon"><i className={section.icon}></i></span>
                                        <span className="setting-tab-link__content">
                                            <span className="setting-tab-link__title-row">
                                                <span className="setting-tab-link__title">{section.title}</span>
                                                <span className="setting-tab-link__badge">{section.badge}</span>
                                            </span>
                                            <span className="setting-tab-link__description">{section.description}</span>
                                        </span>
                                    </Nav.Link>
                                ))}
                            </Nav>
                        </div>
                    </div>

                    <div className="setting-layout__content">
                        <Tab.Content>
                            {availableSections.map((section) => (
                                <Tab.Pane key={section.key} eventKey={section.key}>
                                    <div className="setting-right">
                                        {section.component}
                                    </div>
                                </Tab.Pane>
                            ))}
                        </Tab.Content>
                    </div>
                </div>
            </Tab.Container>
        </>
    )
}
export default Setting;
